module.exports = __webpack_public_path__ + "img/Deploy DAO application.a1b6eae7.svg";